<template>
  <div>
    <v-tooltip bottom>
      <a href="/honey/" slot="activator"
        ><img class="page404" src="/images/404_page.png" alt="PageNotFound404"
      /></a>
      <span>Go Back</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.page404 {
  max-width: 1000px;
  max-height: 800px;
  margin: 110px 0 0 0;
}
</style>
